<template>
    <div>
        <Dialog :visible="visible" class="irinox-dialog-light plans-select-device-dialog" :modal="true"
            :closable="false" :dismissableMask="true" :style="{ width: '1300px' }" :draggable="false"
            @update:visible="updateVisible">

            <template #header>
                <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)"
                    :alt="$t('common.arrow_left')" />
                <div class="plans-compare-title">{{ dialogTitle }}</div>
            </template>

            <div :class="['irinox-dialog-light-content', 'layout-content', 'p-d-flex', 'p-flex-column', 'p-ai-center']"
                style="gap: 10px;">
                <div class="plans-compare-subtitle p-mb-4">{{ $t('plans.select_device_dialog.subtitle') }}</div>
                <div class="irinox-form" style="width: 100%;">
                    <DataTable :value="activableAppliances" stripedRows responsiveLayout="stack" dataKey="serialNumber"
                        breakpoint="900px">

                        <template #empty>{{ $t('plans.select_device_dialog.empty_list') }}</template>

                        <Column field="serialNumber" :header="$t('admin.appliances.col_serialnumber')" />
                        <Column field="modelNumber" :header="$t('admin.appliances.col_model')">
                            <template #body="slotProps">
                                {{ $functions.fixModelName(slotProps.data.modelNumber) }}
                            </template>
                        </Column>
                        <Column field="name" :header="$t('admin.appliances.col_name')">
                            <template #body="slotProps">
                                {{ slotProps.data.name ?? slotProps.data.modelNumber }}
                            </template>
                        </Column>
                        <Column field="labName" :header="$t('admin.appliances.col_lab')" />
                        <Column class="irinox-table-buttons p-text-right">
                            <template #header>
                                <span class="sr-only">{{ $t('common.select') }}</span>
                            </template>
                            <template #body="slotProps">
                                <div class="button-body">
                                    <div class="plan-button" role="button" tabindex="0"
                                        @click="handleBuy(slotProps.data)" @keydown.enter="handleBuy(slotProps.data)"
                                        @keydown.space.prevent="handleBuy(slotProps.data)">
                                        {{ $t('plans.select_device_dialog.btn_buy') }}
                                    </div>
                                </div>
                            </template>
                        </Column>
                    </DataTable>
                </div>

            </div>
            <template #footer></template>
        </Dialog>

        <PlanPaymentRedirect :visible="dialog.paymentRedirect" @update:visible="dialog.paymentRedirect = $event"
            :appliance="selectedAppliance" :selectedPlan="selectedPlanObject" />
    </div>
</template>

<script>
import PlanPaymentRedirect from './PlanPaymentRedirect.vue';

export default {
    emits: ['update:visible'],
    components: {
        PlanPaymentRedirect
    },
    props: {
        visible: Boolean,
        plans: Array,
        appliances: Array,
        selectedPlanCode: String,
        plansMapping: Object
    },
    data() {
        return {
            dialog: {
                paymentRedirect: false
            },
            selectedAppliance: null,
            selectedPlanObject: null
        };
    },
    computed: {
        activableAppliances() {
            if (!this.appliances || !this.selectedPlanCode) return [];
            return this.appliances.filter(a =>
                (this.selectedPlanCode == 'PLUS' && this.hasPlanActivable(a, 'PLUS') && !this.hasPlanActive(a, 'PREMIUM')) 
                ||
                (this.selectedPlanCode == 'PREMIUM' && this.hasPlanActivable(a, 'PREMIUM') && !this.hasPlanActive(a, 'PLUS'))
                ||
                (this.selectedPlanCode == 'GELATERIA' && this.hasPlanActivable(a, 'GELATERIA'))
            );
        },
        dialogTitle() {
            return this.$t(`plans.select_device_dialog.title_${this.selectedPlanCode}`);
        },
        getPlanObject() {
            return this.plans?.find(p => p.code === this.selectedPlanCode) ?? null;
        }
    },
    watch: {},
    created() { },
    mounted() { },
    methods: {
        updateVisible(value) {
            this.$emit('update:visible', value);
        },
        handleBuy(appliance) {
            this.selectedAppliance = appliance;
            this.selectedPlanObject = this.getPlanObject;
            this.updateVisible(false);
            this.dialog.paymentRedirect = true;
        },
        hasPlanActive(appliance, planCode) {
            return appliance?.plans?.some(plan => plan.code === planCode && plan.startDate !=null);
        },
        hasPlanActivable(appliance, planCode) {
            return appliance?.plans?.some(plan => plan.code === planCode && plan.startDate == null);
        },
    }
}
</script>

<style scoped></style>
